import { render, staticRenderFns } from "./AdminShell.vue?vue&type=template&id=f0db3aac&scoped=true"
import script from "./AdminShell.vue?vue&type=script&lang=js"
export * from "./AdminShell.vue?vue&type=script&lang=js"
import style0 from "./AdminShell.vue?vue&type=style&index=0&id=f0db3aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0db3aac",
  null
  
)

export default component.exports